import React from 'react';
import Icon from '@ant-design/icons';
import { ArrowDownSvg, CloseSvg, AddSvg } from '../../../assets/icons';

// Icon components for the Core Brands table. They sit in their own module so the
// files that consume them can export non-components and keep Fast Refresh, which
// only works for a file whose exports are all components.

export const ArrowDownIcon = (props: any) => <Icon component={ArrowDownSvg} {...props} />;
export const CloseIcon = (props: any) => <Icon component={CloseSvg} {...props} />;
export const AddIcon = (props: any) => <Icon component={AddSvg} {...props} />;
